export const KNOWLEDGE_SOURCE_STATES = Object.freeze({
  CLOUD_UNCONFIGURED: 'cloud_unconfigured',
  NOT_CONNECTED: 'not_connected',
  NEEDS_SELECTION: 'needs_selection',
  INITIAL_SYNC: 'initial_sync',
  READY: 'ready',
  ATTENTION_REQUIRED: 'attention_required',
  DISCONNECTING: 'disconnecting',
});

const SOURCE_PRESENTATION = Object.freeze({
  [KNOWLEDGE_SOURCE_STATES.CLOUD_UNCONFIGURED]: Object.freeze({
    label: 'Coming soon',
    tone: 'neutral',
    explanation: 'Microsoft 365 sync is being prepared. No connection is available in this environment yet.',
    actionLabel: 'Connect Microsoft 365',
    actionAvailable: false,
  }),
  [KNOWLEDGE_SOURCE_STATES.NOT_CONNECTED]: Object.freeze({
    label: 'Not set up yet',
    tone: 'warning',
    explanation: 'Connect Microsoft 365 to choose the SharePoint and OneDrive locations Restack may index.',
    actionLabel: 'Connect Microsoft 365',
    actionAvailable: true,
  }),
  [KNOWLEDGE_SOURCE_STATES.NEEDS_SELECTION]: Object.freeze({
    label: 'Choose locations',
    tone: 'warning',
    explanation: 'Authorization is complete. Choose the sites, libraries, or folders Restack should sync.',
    actionLabel: 'Choose locations',
    actionAvailable: true,
  }),
  [KNOWLEDGE_SOURCE_STATES.INITIAL_SYNC]: Object.freeze({
    label: 'Syncing',
    tone: 'warning',
    explanation: 'Restack is indexing the selected Microsoft 365 locations. This continues in the background.',
    actionLabel: 'Syncing',
    actionAvailable: false,
  }),
  [KNOWLEDGE_SOURCE_STATES.READY]: Object.freeze({
    label: 'Available',
    tone: 'success',
    explanation: 'Selected SharePoint and OneDrive locations are available to the Knowledge Locker.',
    actionLabel: 'Manage locations',
    actionAvailable: true,
  }),
  [KNOWLEDGE_SOURCE_STATES.ATTENTION_REQUIRED]: Object.freeze({
    label: 'Needs attention',
    tone: 'error',
    explanation: 'Microsoft 365 needs administrator attention before syncing can continue.',
    actionLabel: 'Review setup',
    actionAvailable: true,
  }),
  [KNOWLEDGE_SOURCE_STATES.DISCONNECTING]: Object.freeze({
    label: 'Disconnecting',
    tone: 'neutral',
    explanation: 'Restack is removing the Microsoft 365 connection and stopping future syncs.',
    actionLabel: 'Disconnecting',
    actionAvailable: false,
  }),
});

export function knowledgeSourcePresentation(source = null) {
  const state = typeof source === 'string' ? source : source?.state;
  return SOURCE_PRESENTATION[state]
    ? Object.freeze({ state, ...SOURCE_PRESENTATION[state] })
    : Object.freeze({
      state: KNOWLEDGE_SOURCE_STATES.CLOUD_UNCONFIGURED,
      ...SOURCE_PRESENTATION[KNOWLEDGE_SOURCE_STATES.CLOUD_UNCONFIGURED],
    });
}

export default knowledgeSourcePresentation;
